"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefreshAction = exports.refreshBroadcastChannel = void 0;
const react_1 = require("react");
const Storage_1 = require("../../Storage");
const useAuth_1 = require("./useAuth");
const AuthProvider_1 = require("../providers/AuthProvider");
const Config_1 = require("../../Config");
const REFRESH_MAX_EVERY_MS = 1000;
const getExceededTime = (date) => {
    return new Date().getTime() - date.getTime();
};
exports.refreshBroadcastChannel = new BroadcastChannel("window-refresh");
const useRefreshAction = () => {
    const { logout } = (0, useAuth_1.useAuth)();
    const dispatch = (0, AuthProvider_1.useAuthDispatch)();
    const activity = (0, AuthProvider_1.useAuthSelector)(state => state.activity);
    const [getStoredActivity, saveActivity] = (0, Storage_1.useStorage)("activity");
    const latestRefresh = activity?.latestRefresh ? new Date(activity?.latestRefresh) : new Date();
    const latestRefreshRef = (0, react_1.useRef)(new Date());
    const initialLatestActivityCheck = () => {
        const storedActivity = getStoredActivity();
        if (storedActivity) {
            const exceededTime = getExceededTime(new Date(storedActivity.latestRefresh));
            if (exceededTime > (0, Config_1.getConfigValue)('AUTH_TIMEOUT_BACK_IN_APP')) {
                logout();
                return false;
            }
            else {
                refresh();
                return true;
            }
        }
        else {
            refresh();
            return false;
        }
    };
    (0, react_1.useEffect)(() => {
        if (!latestRefresh)
            refresh();
    }, [latestRefresh]);
    const setLatestRefresh = () => {
        dispatch(AuthProvider_1.AuthAction.refreshAuth(undefined));
    };
    const postRefreshBroadcastMessage = () => {
        exports.refreshBroadcastChannel.postMessage("refresh-activity");
    };
    const refresh = () => {
        const refreshDate = new Date();
        saveActivity({ latestRefresh: refreshDate });
        latestRefreshRef.current = refreshDate;
        setLatestRefresh();
        postRefreshBroadcastMessage();
    };
    const refreshAction = () => {
        if (getExceededTime(latestRefreshRef.current) > REFRESH_MAX_EVERY_MS)
            refresh();
    };
    return {
        refresh,
        refreshAction,
        latestActivity: latestRefresh,
        initialLatestActivityCheck
    };
};
exports.useRefreshAction = useRefreshAction;
